<template>
<div>
	<span v-if="validation" style="color: red;
    font-size: 20px;
    padding-right: 3px;">*</span>
	<span style="font-size:14px;
	font-family:Microsoft YaHei;
	font-weight:bold;
	color:rgba(51,51,51,1);">{{lable}}：</span>
	<VsSelect 
		style="display: inline-block;background:rgba(255,255,255,1);border-radius:3px;"
	:lablewidth="lablewidth" :width="width"
	:classtype="classtype"
	v-model="select.value"
	:loopdata="select.droplist"
	:keys="['ZGMC','ZGID']"
	@input="fnInputAct"
	@on-enter="fnEnterpressAct"
	@click="fnInputSelect"
	@inputserch="fnInputSelect"
	:requiremore="select.requiremore"
	@require="fnInputSelect"
	@on-confirm="fnSelectConfirm"
	>
	</VsSelect>
</div>
</template>

<script>
	export default{
		props:{
			loopdata:{},
			keys:{},
			lablewidth:{},
			width:{},
			lable:{},
			classtype:{},
			selectValue:{},
			returnkey:{},
			validation:{}
		},
		model: {
			prop: 'selectValue',
			event: 'on-model'
		},
		watch:{
			selectValue(nval){
				//this.select.value=nval
			}
			
		},
		data(){
			return{
				select:{
					value:'',
					PageNo:'1',
					PageSize:'50',
					requiremore:true,
					droplist:[],
					},
			}
		},
		methods:{
			fnInputAct($event){
				this.select.droplist=[]
				this.select.PageNo=1
				this.select.requiremore=true
				this.fnSelectConfirm()
				this.$emit('input',$event)
				if(this.selectValue){this.$emit('on-model',"")}
			},
			fnInputSelect(){
			this.select.value = ''
			if(this.select.requiremore){
					let params=this.$fun.GetUserConstant()
					params.Operators='模糊查询'
					params.PageSize=this.select.PageSize
					params.PageNo=this.select.PageNo
					params.Values=this.select.value
					// console.log(params)
					this.$Api.ErpYGinfoGetbyPromiss(params).then((res)=>{
						// console.log(res)
						if(res.data.data.page.length>0){
							this.select.droplist = [];
							this.select.droplist = this.select.droplist.concat(res.data.data.page)
							this.select.PageNo++
						}else{
							this.select.requiremore=false
							this.select.PageNo=1
						}
					})
				}
			},
			fnSelectConfirm(data){
				// console.log('returnkey',data)
				if(data){
					if(this.returnkey){
						this.$emit('on-model',data[this.returnkey])
						this.$emit('on-select',data)
					}else{
						this.$emit('on-select',data)
					}
				}else{
					// console.log('else')
				}
			},
			fnEnterpressAct($event){
				this.$emit('on-enter',$event)
			}
		}
	}
</script>

<style>
</style>
